import { render } from "./AppNewsListPage.vue?vue&type=template&id=59ec0a59&ts=true"
import script from "./AppNewsListPage.ts?vue&type=script&lang=ts"
export * from "./AppNewsListPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__